import React, { useCallback } from 'react'
import { makeStyles } from '@material-ui/styles'
import { Button, Menu, MenuItem, Box, Typography, Hidden } from '@material-ui/core'
import { mutualTheme } from '~/utils/theme'
import { ExpandMoreRounded } from '@material-ui/icons'
import { useMuiMenuHelper } from '~/hooks/useMuiToggle'
import { useSignOut } from '~/store/auth/useSignOut'
import { useAuthAccount } from '~/store/auth/useAuthAccount'

type AccountMenuStyleParams = {
  menuItemWidth?: number
}

const useStyles = makeStyles({
  profileImage: {
    borderRadius: '100%'
  },
  menuItem: {
    fontFamily: 'Airbnb',
    minWidth: (props: AccountMenuStyleParams) => props.menuItemWidth
  },
  button: {
    [mutualTheme.breakpoints.down('md')]: {
      padding: 0
    }
  },
  profileName: {
    fontWeight: 500,
    textTransform: 'none',
    color: mutualTheme.palette.common.black,
    marginLeft: mutualTheme.spacing(2)
  }
})

export const AccountMenu: React.FC = () => {
  const [isMenuOpen, onOpen, onClose, selectedElement] = useMuiMenuHelper()
  const classes = useStyles({ menuItemWidth: selectedElement?.clientWidth })
  const signOut = useSignOut()
  const { nickname, profilePicture } = useAuthAccount()

  const handleOnExit = useCallback(() => {
    onClose()
    signOut()
  }, [onClose, signOut])

  return (
    <>
      <Button className={classes.button} onClick={onOpen} endIcon={<ExpandMoreRounded color='action' />}>
        <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {profilePicture && (
            <img
              alt='pic'
              width={35}
              height={35}
              className={classes.profileImage}
              src={profilePicture.originalOptimized as (string | undefined)}
            />
          )}
          <Hidden mdDown>
            <Typography variant='airbnbBody1' className={classes.profileName}>
              {nickname}
            </Typography>
          </Hidden>
        </Box>
      </Button>
      <Menu
        open={isMenuOpen}
        onClose={onClose}
        id='auth-account-menu'
        anchorEl={selectedElement}
      >
        <MenuItem className={classes.menuItem} onClick={handleOnExit}>
          Sair
        </MenuItem>
      </Menu>
    </>
  )
}
